<template>
  <div v-show="Object.keys(selling).length > 0">
    <div class="row mb-5 best-selling-product">
      <div class="col-12 col-md-4">
        <div class="main-card card h-100 p-4 top-selling">
          <div class="card-thumbnail">
            <Image :src="bestSelling.thumbnail" v-if="bestSelling.thumbnail" class="img" />
          </div>
          <div class="card-title">
            {{ bestSelling.title }}
          </div>
          <div class="card-description row">
            <div class="col-12 id">
              <p class="label">ID</p>
              <p>{{ bestSelling.product_id }}</p>
            </div>
            <div class="col-12 quantity">
              <p class="label">Quantity Sold</p>
              <p class="text-warning">{{ bestSelling.number }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8">
        <div class="main-card card h-100">
          <div class="card-header">Selling Products</div>
          <div class="table-responsive">
            <table class="align-middle mb-0 table table-borderless table-striped table-hover">
              <thead>
                <tr>
                  <th class="text-center">ID</th>
                  <th>Name</th>
                  <th class="text-center">Quantity Sold</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="product in selling" :key="product.identify">
                  <td class="text-center text-muted">{{ product.identify }}</td>
                  <td>
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left flex2">
                          <div class="widget-heading">{{ product.title }}</div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-center">{{ product.number }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    data() {
      return this.config
    },
    bestSelling() {
      let selling = this.data?.best_selling
      return Object.assign(
        {
          title: '',
          product_id: '',
          thumbnail: ''
        },
        _.isObjectLike(selling) ? selling[0] : {}
      )
    },
    selling() {
      let selling = Object.assign([], this.data?.best_selling)
      return selling.slice(1, selling.length + 1)
    }
  },
  props: {
    config: Object
  }
}
</script>
